import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { QueryNavigationService } from '../../../core/services/query-navigation.service';
import { AsyncPipe } from '@angular/common';
import { Store } from '@ngrx/store';
import { APPLICATION_REDUCER } from '../../../store/reducers/application.reducer';
import { EScreenSizeBreakPoint } from '../../../core/configurations/application';
import { Observable, combineLatest } from 'rxjs';

@Component({
  selector: 'cv-query-navigation',
  standalone: true,
  imports: [ButtonModule, AsyncPipe],
  template: `
    @if (data$ | async; as data) {
      <nav class="navigation">
        <p-button icon="pi pi-arrow-left" (click)="service.navigate('back')" severity="info" />
        <p class="ml-5 mr-5">
          {{ service.currentNavState }} of {{ data.ids.length }} {{ data.isMobileScreen ? '' : 'Conversations' }}
        </p>
        <p-button icon="pi pi-arrow-right" (click)="service.navigate('forward')" severity="info" />
        @if (data.isMarkCompleteOn) {
          <p-button
            class="navigation__complete-btn"
            (click)="service.navigate('skip')"
            severity="info"
            [icon]="data.isMobileScreen ? 'pi pi-check' : ''"
            [label]="data.isMobileScreen ? '' : 'Mark Complete'"
            [rounded]="!data.isMobileScreen"
          />
        }
      </nav>
    }
  `,
  styleUrl: './query-navigation.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class QueryNavigationComponent {
  readonly data$: Observable<IQueryNavigationComponentData> = combineLatest({
    ids: this.service.ids$,
    isMarkCompleteOn: this.service.isMarkCompleteActive$,
    isMobileScreen: this.store.select(APPLICATION_REDUCER.isScreenSizeBreakpoint(EScreenSizeBreakPoint.xs)),
  });

  constructor(
    readonly service: QueryNavigationService,
    private readonly store: Store,
  ) {}
}

interface IQueryNavigationComponentData {
  ids: string[];
  isMobileScreen: boolean;
  isMarkCompleteOn: boolean;
}
